import React from 'react';
import { router, useLocalSearchParams } from 'expo-router';
import { Text, TextInput, Button, HelperText } from 'react-native-paper';
import { View, Platform, Keyboard } from 'react-native';
import axios from 'axios';
import { useSession } from '../../ctx/ctx';
import { MainContext } from '../../contexts/MainContext';
import AppBar from '../../components/AppBar/AppBar';

export default function VerifyMobile() {
  const { signIn } = useSession();
  const { mobile } = useLocalSearchParams();
  const [otp, setOtp] = React.useState("");
  const [counter, setCounter] = React.useState(100);
  const [otpCheck, setOtpCheck] = React.useState(false);
  const [requestLoading, setRequestLoading] = React.useState(false);
  const myContext = React.useContext(MainContext);

  React.useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter])

  const verifyOtp = (mobile, code) => {
    setRequestLoading(true);
    axios.post(`/phone-login-verfriy`, {phone: mobile, code: code})
      .then((response) => {
        if(response.data.status) {
          signIn(response.data.token);
          setTimeout(() => {
            router.replace('/');
          }, 500);
          myContext.setUserData(response.data.user);
          myContext.activateSnackbar(true, response.data.message);
          axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.token;
          axios.defaults.baseURL = `https://40lsoton.ir/api`;
          axios.defaults.headers.common['Cache-Control'] = 'no-cache';
          axios.defaults.headers.common['Pragma'] = 'no-cache';
          axios.defaults.headers.common['Expires'] = '0';
          setRequestLoading(false);
        } else {
          myContext.activateSnackbar(true, response.data.message);
          setRequestLoading(false);
        }
      })
      .catch(myContext.handleAxiosError)
      .finally(() => setRequestLoading(false));
  }
  
  return (
    <>
      <AppBar leftText="ویرایش شماره موبایل" />
      <View style={{ flex: 1, paddingHorizontal: 18, backgroundColor: '#fff', justifyContent: 'space-between' }}>
        <View>
          <Text style={{ fontSize: 16, textAlign: Platform.OS === 'web' ? 'right' : 'left', direction: 'rtl', fontFamily: 'IRANSans_Medium', color: '#292d39', marginTop: 32, marginBottom: 8 }}>کد تایید را وارد کنید:</Text>
          <Text style={{ fontSize: 12, textAlign: Platform.OS === 'web' ? 'right' : 'left', direction: 'rtl', color: '#5b5e63', marginBottom: 24 }}>کد 6 رقمی ارسال شده به شماره {mobile} را وارد کنید.</Text>
          <TextInput
            label="کد تایید"
            placeholder="کد تایید ارسال شده را وارد کنید"
            mode="outlined"
            error={otpCheck}
            value={otp}
            style={{ fontSize: 14 }}
            activeOutlineColor="#c6c5c4"
            keyboardType='number-pad'
            maxLength={6}
            onChangeText={text => {setOtp(text); if(text.length === 6) {Keyboard.dismiss()} }}
          />
          <HelperText type="error" visible={otpCheck}>لطفا کد ارسال شده را بدرستی وارد کنید</HelperText>
        </View>
        <View style={{ paddingBottom: 85 }}>
          <Button loading={requestLoading} disabled={counter === 0 ? true : requestLoading} labelStyle={{ fontSize: 16 }} style={{ marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={() => verifyOtp(mobile, otp)}>ورود</Button>
          {
            counter === 0 ?
              <Text onPress={() => router.replace(-1)} style={{ fontSize: 12, color: '#5b5e63', textAlign: 'center', marginTop: 6 }}>دریافت دوباره کد</Text>
            :
              <Text style={{ fontSize: 12, color: '#c6c4c5', textAlign: 'center', marginTop: 6 }}>دریافت دوباره کد ({counter} ثانیه)</Text>
          }
        </View>
      </View>
    </>
  );
}
